namespace $.$$ {

	type $shm_hitalama_settings_tauri_config = {
		selfhosted_tauri?: boolean
		port?: number
		actual_port?: number
		port_occupied?: number
		domain_link?: string
		domain?: string
		master?: string
		tunnel_enabled?: boolean
		ssh_host?: string
		ssh_user?: string
		ssh_port?: number
		remote_port?: number
		ssh_key?: string
		tunnel_status?: string
	}

	export class $shm_hitalama_settings extends $.$shm_hitalama_settings {

		static selfhosted_tauri_enabled(): boolean {
			const key = `${ this }.selfhosted_tauri_enabled`
			const arg = Boolean(
				this.$.$mol_state_arg.value( 'tauri_port' )
				|| this.$.$mol_state_arg.value( 'tauri_port_occupied' )
				|| this.$.$mol_state_arg.value( 'selfhosted_tauri' )
			)
			if( arg ) this.$.$mol_state_local.value( key, true )
			if( !this.tauri_available() ) return false
			const config = this.$.$mol_error_fence(
				()=> this.tauri_config(),
				()=> null,
				()=> null,
			)
			if( config?.selfhosted_tauri ) this.$.$mol_state_local.value( key, true )
			return this.$.$mol_state_local.value< boolean >( key ) ?? false
		}

		static tauri_arg< Value >( name: string, next?: Value ) {
			const key = `${ this }.${ name }.arg`
			if( next !== undefined ) return this.$.$mol_state_local.value( key, next )
			const arg = this.$.$mol_state_arg.value( name )
			if( arg !== null ) return this.$.$mol_state_local.value( key, arg )
			return this.$.$mol_state_local.value< Value >( key )
		}

		static tauri_config_uri() {
			return '/hitalama_tauri_config'
		}

		static tauri_available() {
			return Boolean(
				this.$.$mol_state_arg.value( 'tauri_port' )
				|| this.$.$mol_state_arg.value( 'tauri_port_occupied' )
				|| this.$.$mol_state_arg.value( 'selfhosted_tauri' )
				|| ( globalThis as any ).__TAURI__
				|| ( globalThis as any ).__TAURI_INTERNALS__
			)
		}

		@ $mol_mem
		static tauri_config( next?: $shm_hitalama_settings_tauri_config ): $shm_hitalama_settings_tauri_config {
			if( next ) return next
			if( !this.tauri_available() ) return { selfhosted_tauri: false }
			return this.$.$mol_fetch.json( this.tauri_config_uri() ) as $shm_hitalama_settings_tauri_config
		}

		static tauri_field< Value >( name: string, next: Value | undefined, fallback: Value ) {
			const key = `${ this }.${ name }`
			if( next !== undefined ) return this.$.$mol_state_local.value( key, next ) ?? fallback
			const local = this.$.$mol_state_local.value< Value >( key )
			if( local !== undefined && local !== null ) return local
			const config = this.$.$mol_error_fence(
				()=> this.tauri_config(),
				()=> ({} as $shm_hitalama_settings_tauri_config),
				()=> ({} as $shm_hitalama_settings_tauri_config),
			)
			return ( config as any )[ name ] ?? fallback
		}

		tauri_config() {
			return $shm_hitalama_settings.tauri_config()
		}

		selfhosted_tauri_link() {
			return $shm_hitalama_settings.selfhosted_tauri_enabled() ? this.Selfhosted_tauri_link() : null
		}

		selfhosted_tauri_content() {
			return $shm_hitalama_settings.selfhosted_tauri_enabled() ? [ this.Selfhosted_tauri_config() ] : []
		}

		tauri_port_conflict_message() {
			const occupied = Number( $shm_hitalama_settings.tauri_arg( 'tauri_port_occupied' ) || 0 )
			if( !occupied ) return ''
			return `Порт ${ occupied } занят. Приложение запущено на ${ $shm_hitalama_settings.tauri_arg( 'tauri_port' ) }.`
		}

		tauri_port_conflict_message_visible() {
			return this.tauri_port_conflict_message() ? [ this.Tauri_port_conflict_message() ] : []
		}

		tauri_port( next?: number ) {
			if( next !== undefined ) return $shm_hitalama_settings.tauri_field( 'port', next, 9090 )
			return $shm_hitalama_settings.tauri_field( 'port', next, Number( $shm_hitalama_settings.tauri_arg( 'tauri_port_occupied' ) || 9090 ) )
		}

		tauri_domain( next?: string ) {
			return $shm_hitalama_settings.tauri_field( 'domain', next, '' )
		}

		tauri_master( next?: string ) {
			return $shm_hitalama_settings.tauri_field( 'master', next, '' )
		}

		tauri_tunnel_enabled( next?: boolean ) {
			return $shm_hitalama_settings.tauri_field( 'tunnel_enabled', next, false )
		}

		tauri_ssh_host( next?: string ) {
			return $shm_hitalama_settings.tauri_field( 'ssh_host', next, '' )
		}

		tauri_ssh_user( next?: string ) {
			return $shm_hitalama_settings.tauri_field( 'ssh_user', next, '' )
		}

		tauri_ssh_port( next?: number ) {
			return $shm_hitalama_settings.tauri_field( 'ssh_port', next, 22 )
		}

		tauri_remote_port( next?: number ) {
			return $shm_hitalama_settings.tauri_field( 'remote_port', next, 80 )
		}

		tauri_ssh_key( next?: string ) {
			return $shm_hitalama_settings.tauri_field( 'ssh_key', next, '' )
		}

		@ $mol_mem
		tauri_save_message( next?: string ) {
			return next ?? ''
		}

		@ $mol_action
		tauri_save( next?: any ) {
			const config: $shm_hitalama_settings_tauri_config = {
				port: Number( this.tauri_port() ) || 9090,
				domain: this.tauri_domain(),
				master: this.tauri_master(),
				tunnel_enabled: this.tauri_tunnel_enabled(),
				ssh_host: this.tauri_ssh_host(),
				ssh_user: this.tauri_ssh_user(),
				ssh_port: Number( this.tauri_ssh_port() ) || 22,
				remote_port: Number( this.tauri_remote_port() ) || 80,
				ssh_key: this.tauri_ssh_key(),
			}

			const saved = this.$.$mol_fetch.json( $shm_hitalama_settings.tauri_config_uri(), {
				method: 'PUT',
				headers: { 'content-type': 'application/json' },
				body: JSON.stringify( config ),
			} ) as $shm_hitalama_settings_tauri_config

			$shm_hitalama_settings.tauri_config( saved )
			this.tauri_save_message( 'Сохранено. Порт применится после перезапуска приложения, SSH-туннель перезапускается автоматически.' )
		}

		static mic( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.mic', next ) ?? ''
		}

		static speaker( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.speaker', next ) ?? ''
		}

		static agent_settings( next?: $shm_hitalama_settings_agent_data ): $shm_hitalama_settings_agent_data {
			type Agent_settings = $shm_hitalama_settings_agent_data

			const mirror_local = ( settings: Agent_settings )=> {
				if( settings.url !== undefined ) this.$.$mol_state_local.value( 'hitalama_agent_url', settings.url )
				if( settings.token !== undefined ) this.$.$mol_state_local.value( 'hitalama_agent_token', settings.token )
				if( settings.configs !== undefined ) this.$.$mol_state_local.value( 'hitalama_agent_configs', settings.configs )
				if( settings.current !== undefined ) this.$.$mol_state_local.value( 'hitalama_agent_current', settings.current )
				return settings
			}

			const profile = this.$.$shm_hitalama_profile.current()
			if( profile ) {
				const prev = this.$.$mol_error_fence(
					()=> ( profile.store( 'agent_settings' ) ?? {} ) as Agent_settings,
					()=> ({}),
					()=> ({}),
				)
				if( next !== undefined ) return mirror_local( this.$.$mol_error_fence(
					()=> profile.store( 'agent_settings', {
						... prev,
						... next,
					} ) as Agent_settings,
					()=> ({
						... prev,
						... next,
					}),
					promise => promise,
				) )
				return mirror_local( prev )
			}

			if( next !== undefined ) mirror_local( next )
			return mirror_local({
				url: this.$.$mol_state_local.value< string >( 'hitalama_agent_url' ) ?? '',
				token: this.$.$mol_state_local.value< string >( 'hitalama_agent_token' ) ?? '',
			configs: this.$.$mol_state_local.value< $shm_hitalama_agent_config[] >( 'hitalama_agent_configs' ) ?? undefined,
				current: this.$.$mol_state_local.value< string >( 'hitalama_agent_current' ) ?? undefined,
			})
		}

		static agent_configs(): readonly $shm_hitalama_agent_config[] {
			const settings = this.agent_settings()
			const local = this.$.$mol_state_local.value< $shm_hitalama_agent_config[] >( 'hitalama_agent_configs' )
			const source = Array.isArray( settings.configs ) ? settings.configs : local
			const configs = [] as $shm_hitalama_agent_config[]
			const ids = new Set< string >()

			for( const [ index, source_config ] of ( source ?? [] ).entries() ) {
				if( !source_config || typeof source_config !== 'object' ) continue
				const id = String( source_config.id || `config-${ index + 1 }` )
				if( ids.has( id ) ) continue
				ids.add( id )
				const url = String( source_config.url ?? '' )
				configs.push({
					id,
					name: String( source_config.name || `Конфигурация ${ configs.length + 1 }` ),
					backend: source_config.backend
						? $shm_hitalama_agent_provider.normalize( source_config.backend )
						: this.agent_backend_default( url ),
					url,
					token: String( source_config.token ?? '' ),
					mcp_url: String( source_config.mcp_url ?? '' ),
					...( source_config.mcp_token !== undefined ? { mcp_token: String( source_config.mcp_token ) } : {} ),
					...( source_config.local_url !== undefined ? { local_url: String( source_config.local_url ) } : {} ),
					...( source_config.local_mcp_url !== undefined ? { local_mcp_url: String( source_config.local_mcp_url ) } : {} ),
				})
			}

			if( configs.length ) return configs
			const url = String(
				settings.url
					?? this.$.$mol_state_local.value< string >( 'hitalama_agent_url' )
					?? ''
			).trim() || this.agent_url_default()
			return [{
				id: 'default',
				name: 'Основная',
				backend: this.agent_backend_default( url ),
				url,
				token: String(
					settings.token
						?? this.$.$mol_state_local.value< string >( 'hitalama_agent_token' )
						?? ''
				),
				mcp_url: '',
			}]
		}

		static agent_backend_default( url: string ): $shm_hitalama_agent_backend {
			return $shm_hitalama_agent_provider.infer( url )
		}

		static agent_config_current( next?: string ): string {
			const configs = this.agent_configs()
			if( next === undefined ) {
				const stored = String(
					this.agent_settings().current
						?? this.$.$mol_state_local.value< string >( 'hitalama_agent_current' )
						?? ''
				)
				return configs.some( config => config.id === stored ) ? stored : configs[ 0 ].id
			}

			const current = configs.find( config => config.id === next ) ?? configs[ 0 ]
			this.agent_settings({
				configs: [ ... configs ],
				current: current.id,
				url: current.url,
				token: current.token,
			})
			return current.id
		}

		static agent_config( id: string, next?: Partial< $shm_hitalama_agent_config > ) {
			const configs = this.agent_configs()
			const current = configs.find( config => config.id === id ) ?? configs[ 0 ]
			if( next === undefined ) return current

			const changed = configs.map( config => config.id === id ? {
				... config,
				... next,
				id: config.id,
			} : config )
			const active_id = this.agent_config_current()
			const active = changed.find( config => config.id === active_id ) ?? changed[ 0 ]
			this.agent_settings({
				configs: changed,
				current: active.id,
				url: active.url,
				token: active.token,
			})
			return changed.find( config => config.id === id ) ?? active
		}

		static agent_config_add( config: $shm_hitalama_agent_config ) {
			const configs = this.agent_configs()
			if( configs.some( item => item.id === config.id ) ) return config.id
			this.agent_settings({ configs: [ ... configs, config ] })
			return config.id
		}

		static agent_config_remove( id: string ) {
			const configs = this.agent_configs()
			if( configs.length === 1 ) return configs[ 0 ].id
			const changed = configs.filter( config => config.id !== id )
			const current_id = this.agent_config_current()
			const active = changed.find( config => config.id === current_id ) ?? changed[ 0 ]
			this.agent_settings({
				configs: changed,
				current: active.id,
				url: active.url,
				token: active.token,
			})
			return active.id
		}

		static agent_url_default( backend: $shm_hitalama_agent_backend = 'opencode' ): string {
			return $shm_hitalama_agent_provider.url_default( backend )
		}

		static agent_url( next?: string ): string {
			return this.agent_config_url( this.agent_config_current(), next )
		}

		static agent_connection( id: string, next?: string ): 'local' | 'remote' {
			const profile = this.$.$shm_hitalama_profile.current()?.link().str ?? 'local'
			const key = `hitalama_agent_connection_${ profile }_${ id }`
			const mode = this.$.$mol_state_local.value< string >( key, next )
			return mode === 'local' ? 'local' : 'remote'
		}

		static agent_config_url( id: string, next?: string ): string {
			const local = this.agent_connection( id ) === 'local'
			const field = local ? 'local_url' : 'url'
			if( next !== undefined ) return String( this.agent_config( id, { [field]: next } )[field] ?? '' )
			const config = this.agent_config( id )
			return String( config[field] ?? '' ).trim() || ( local
				? $shm_hitalama_agent_provider.local_url_default( config.backend )
				: this.agent_url_default( config.backend ) )
		}

		static agent_token( next?: string ): string {
			const current = this.agent_config_current()
			if( next !== undefined ) return String( this.agent_config( current, { token: next }).token ?? '' )
			return String( this.agent_config( current ).token ?? '' )
		}

		static agent_mcp_url_default( backend: $shm_hitalama_agent_backend ) {
			return $shm_hitalama_agent_provider.mcp_url_default( backend )
		}

		static agent_mcp_token( next?: string ): string {
			const current = this.agent_config_current()
			if( next !== undefined ) return this.agent_config( current, { mcp_token: next } ).mcp_token ?? ''
			return this.agent_config( current ).mcp_token?.trim() || this.agent_token()
		}

		static agent_mcp_url( next?: string ): string {
			return this.agent_config_mcp_url( this.agent_config_current(), next )
		}

		static agent_config_mcp_url( id: string, next?: string ): string {
			const local = this.agent_connection( id ) === 'local'
			const field = local ? 'local_mcp_url' : 'mcp_url'
			if( next !== undefined ) {
				return String( this.agent_config( id, { [field]: next } )[field] ?? '' )
			}
			const config = this.agent_config( id )
			const stored = String( config[field] ?? '' ).trim()
			if( stored ) return stored
			if( local ) return 'ws://127.0.0.1:4817/hitalama-mcp'
			const legacy = this.$.$mol_state_local.value< string >( 'hitalama_mcp_url' )?.trim()
			return legacy || this.agent_mcp_url_default( config.backend )
		}

		static agent_backend(): $shm_hitalama_agent_backend {
			return this.agent_config( this.agent_config_current() ).backend
		}

		static github_token( next?: string ): string {
			const profile = this.$.$shm_hitalama_profile.current()
			if( profile ) return profile.secret_val( 'github_token', next )
			return this.$.$mol_state_local.value( 'hitalama_github_token', next ) ?? ''
		}

		static github_owner( next?: string ): string {
			const profile = this.$.$shm_hitalama_profile.current()
			if( profile ) return profile.secret_val( 'github_owner', next === undefined ? undefined : next.trim() )
			return this.$.$mol_state_local.value( 'hitalama_github_owner', next === undefined ? undefined : next.trim() ) ?? ''
		}

		mic( next?: string ): string {
			return $shm_hitalama_settings.mic( next )
		}

		speaker( next?: string ): string {
			return $shm_hitalama_settings.speaker( next )
		}

		agent_url( next?: string ): string {
			return $shm_hitalama_settings.agent_url( next )
		}

		agent_token( next?: string ): string {
			return $shm_hitalama_settings.agent_token( next )
		}

		github_token( next?: string ): string {
			return $shm_hitalama_settings.github_token( next )
		}

		github_owner( next?: string ): string {
			return $shm_hitalama_settings.github_owner( next )
		}

		@ $mol_mem
		microphones() {
			const devices = $mol_wire_sync( navigator.mediaDevices ).enumerateDevices()
			const microphones = devices.filter( device => device.kind === 'audioinput' )

			const dict: Record< string, string > = {
				'': 'По умолчанию',
			}
			microphones.forEach( ( mic, index )=> {
				dict[ mic.deviceId ] = `${ index }: ${ mic.label || 'Без названия' }`
			} )

			return dict
		}

		static stick_px( next?: number ): number {
			return this.$.$mol_state_local.value( this+'.stick_px', next ) ?? 200
		}

		stick_px( next?: number ): number {
			return $shm_hitalama_settings.stick_px( next )
		}

		static widget_float_resizer_size( next?: number ): number {
			return this.$.$mol_state_local.value( this+'.widget_float_resizer_size', next ) ?? 10
		}

		widget_float_resizer_size( next?: number ): number {
			return $shm_hitalama_settings.widget_float_resizer_size( next )
		}

		static widget_keyboard_move_step_px( next?: number ): number {
			return this.$.$mol_state_local.value( this+'.widget_keyboard_move_step_px', next ) ?? 1
		}

		widget_keyboard_move_step_px( next?: number ): number {
			return $shm_hitalama_settings.widget_keyboard_move_step_px( next )
		}

		static slideshow_mode_key( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.slideshow_mode_key', next ) ?? ''
		}

		slideshow_mode_key( next?: string ): string {
			return $shm_hitalama_settings.slideshow_mode_key( next )
		}

		static fullscreen_disable_key( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.fullscreen_disable_key', next ) ?? 'Escape'
		}

		fullscreen_disable_key( next?: string ): string {
			return $shm_hitalama_settings.fullscreen_disable_key( next )
		}

		static drag_mode_key( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.drag_mode_key', next ) ?? 'Control'
		}

		drag_mode_key( next?: string ): string {
			return $shm_hitalama_settings.drag_mode_key( next )
		}

		static drawing_mode_key( next?: string ): string {
			return this.$.$mol_state_local.value( this+'.drawing_mode_key', next ) ?? 'P'
		}

		drawing_mode_key( next?: string ): string {
			return $shm_hitalama_settings.drawing_mode_key( next )
		}

		static dragger_keep_size( next?: boolean ): boolean {
			return this.$.$mol_state_local.value( this+'.dragger_keep_size', next ) ?? true
		}

		dragger_keep_size( next?: boolean ): boolean {
			return $shm_hitalama_settings.dragger_keep_size( next )
		}

		overlayed_map() {
			return $shm_hitalama_profile.current()?.overlayed_map() ?? null
		}

		@ $mol_mem
		overlayed_map_enabled( next?: boolean ): boolean {
			return $shm_hitalama_profile.current()?.overlayed_map_enabled( next ) ?? false
		}

		template_map( id: string ) {
			const profile = $shm_hitalama_profile.current()

			switch( id ) {
				case 'js': return profile?.templates_js() ?? null
				case 'tsx': return profile?.templates_tsx() ?? null
				case 'sql': return profile?.templates_sql() ?? null
				case 'commands': return profile?.templates_commands() ?? null
			}

			return null
		}

	}

	export class $shm_hitalama_settings_agent_string extends $.$shm_hitalama_settings_agent_string {

		@ $mol_action
		autocomplete_unlock( next?: Event ) {
			if( next ) this.autocomplete_locked( false )
			return next ?? null
		}

	}

}
